import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { SystemConfigrationRoutes } from '../../../routes/HomeRoutes/SystemConfigrationRoutes';

export const SystemConfigrationLayout = () => <SwitchRoute routes={SystemConfigrationRoutes} />;
